<template>
  <div class="d-flex flex-nowrap align-center">
    <div
      class="caption-graph"
      ref="captionGraph"
      :style="getCaptionGraphStyle()"
    ></div>
    <p class="mb-0 ml-2">{{ captionText }}</p>
  </div>
</template>

<script>
export default {
  name: 'caption-graph',
  props: ['isEstimated', 'backgroundColor', 'captionText'],
  methods: {
    getCaptionGraphStyle() {
      if (this.isEstimated) {
        return `background-color: ${this.backgroundColor};background-image: linear-gradient(135deg, rgba(255, 255, 255, 0.25) 25%, transparent 0, transparent 50%, rgba(255, 255, 255, 0.25) 0, rgba(255, 255, 255, 0.25) 75%, transparent 0, transparent); background-size: 10px 10px; background-repeat: round;`
      } else {
        return `background-color: ${this.backgroundColor}`
      }
    },
  },
}
</script>

<style scoped>
.caption-graph {
  width: 20px;
  height: 20px;
}
</style>
